var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite-friend"},[_c('top-banner'),_c('invite-main'),_c('activity-footer'),_c('div',{staticClass:"btn-invite",on:{"click":_vm.copyInviteLink}},[_vm._v("\n    "+_vm._s(_vm.$t('btnInvite'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }